import { type BackendUrls, env } from "./environment";
import { getHostingEnv } from "./hostingEnvStore";

// Helper to determine if we should use K8s URLs - called at runtime
export const shouldUseK8s = (): boolean => {
    if (env.channel === "voice") {
        return getHostingEnv() === "k8s";
    }

    const serviceProviderOverride = localStorage.getItem("serviceProvider");

    // This ensures we only use K8s URLs for Amazon Connect chat channel
    return env.channel === "chat" && serviceProviderOverride === "AMAZON_CONNECT";
};

export const getBackendUrls = (): BackendUrls => (shouldUseK8s() ? env.backendUrls.k8s : env.backendUrls.aws);
